module.exports = __webpack_public_path__ + "media/images/mprnews-archive-light-bg-widescreen-91f776a2cc5c03ac5c21ea551e67baba.jpg";